const MAX_QUESTIONS_BEFORE_PAYWALL = 60;

export default MAX_QUESTIONS_BEFORE_PAYWALL;
